/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const jsonParse = (data: string, fallback = null) => {
  try {
    return JSON.parse(data);
  } catch {
    return fallback;
  }
};
export default jsonParse;
